import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diconodinoi',
  templateUrl: './diconodinoi.component.html',
  styleUrls: ['./diconodinoi.component.scss']
})
export class DiconodinoiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/diconodinoi/diconodinoi.component.ts